import Countries from './containers/CountriesContainer';

export default Countries;
